// extracted by mini-css-extract-plugin
export default {"element":"PricingTables-module--element--ee047","col":"PricingTables-module--col--f13a7"};